import React, { useState, useEffect, Fragment } from "react";
import PropTypes from "prop-types";

import {
    NavDropdown,
    ListGroup,
    Accordion,
    ListGroupItem
} from "react-bootstrap";
import TypeAhead from "./TypeAhead";
import NavbarLink from "./NavbarLink";
import Axios from "axios";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import VendorOverlayModal from "./Modal/VendorOverlay";

const Vendors = ({ CanI, handleResponse, handleError }) => {
    const [state, setState] = useState({ vendors_add: false });

    useEffect(() => {
        async function InitAsset() {
            setState({
                ...state,
                vendors_add: await CanI("vendors_add")
            });
        }
        InitAsset();
    }, []);

    return (
        <NavDropdown.ItemText>
            <ListGroup>
                <ListGroup.Item>
                    <NavbarLink
                        to="/app/vendors"
                        className="dropdown-item"
                        label={"List View"}
                    />
                </ListGroup.Item>
                <ListGroup.Item className="px-3">
                    <TypeAhead
                        component={"vendors"}
                        style={{ minWidth: "150px" }}
                        type="text"
                        className="form-control"
                        placeholder="Search..."
                    />
                </ListGroup.Item>
            </ListGroup>
            <ListGroup>
                <VendorOverLay
                    handleResponse={handleResponse}
                    handleError={handleError}
                />
            </ListGroup>
        </NavDropdown.ItemText>
    );
};

Vendors.propTypes = { CanI: PropTypes.func };

export default Vendors;

const VendorOverLay = ({ handleResponse, handleError }) => {
    const [modalShow, setModalShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [overlay, setOverlay] = useState({});

    const getTemplate = async() => {
        const response = await Axios.get("/vendors/get-overlay-template", { responseType: "blob" });

        await handleResponse(response, {
            fileName: "Vendor_Overlay",
            extension: ".xlsx"
        });
    };
    const uploadOverlay = async() => {
        setLoading(true);
        const configs = {
            // "content-type": "multipart/form-data",
            responseType: "blob"
        };
        let formData = new FormData();
        formData.append("overlay", overlay);
        try {
            const response = await Axios.post(
                "/vendors/upload-vendor-overlay",
                formData,
                configs
            );
            await handleResponse(response, {
                fileName: "Vendor_Overlay_Error",
                extension: ".xlsx"
            });
        }
        catch (error) {
            await handleError(error);
        }
        setLoading(false);
    };
    const handleSetOverlay = event => {
        if (event.target.files[0]) {
            setOverlay(event.target.files[0]);
        }
    };
    return (
        <Fragment>
            <ListGroup.Item>
                <Accordion>
                    <Card>
                        <Card.Header>
                            <Accordion.Toggle
                                as={Button}
                                variant="light"
                                eventKey="vendors_overlay-toggle-list"
                            >
                                <span className="text-dark">
                                    Vendor Overlay
                                </span>
                            </Accordion.Toggle>
                        </Card.Header>

                        <Accordion.Collapse eventKey="vendors_overlay-toggle-list">
                            <Card.Body>
                                <ListGroup>
                                    <ListGroupItem
                                        onClick={() => setModalShow(true)}
                                        variant="secondary"
                                        as={Button}
                                    >
                                        Vendor Overlay Upload
                                    </ListGroupItem>
                                    <ListGroupItem
                                        onClick={getTemplate}
                                        variant="secondary"
                                        as={Button}
                                    >
                                        Vendor Overlay Template
                                    </ListGroupItem>
                                </ListGroup>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </ListGroup.Item>
            <VendorOverlayModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                handleSetOverlay={handleSetOverlay}
                uploadOverlay={uploadOverlay}
                loading={loading}
            />
        </Fragment>
    );
};